import { jsx as _jsx } from "react/jsx-runtime";
import { useThree } from '@react-three/fiber';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import DragControls from '../../r3f-components/DragControls.tsx/DragControls';
const DragControlsWrapper = ({ enabled }) => {
    const { camera, gl } = useThree();
    const activeSceneId = useSelector((state) => state.userReducer.activeSceneId);
    const tempDragRotation = useSelector((state) => state.userReducer.temporaryDragRotation);
    const forceUpdateDragControlsTrigger = useSelector((state) => state.userReducer.forceUpdateDragControlsTrigger);
    const rootId = useSelector((state) => state.contentReducer.contentDoc.rootComponentId);
    const firstSceneId = useSelector((state) => state.contentReducer.contentDoc.componentsById[rootId].children[0]);
    const componentsById = useSelector((state) => state.contentReducer.contentDoc.componentsById);
    const currentSceneId = activeSceneId ?? firstSceneId;
    const currentScene = componentsById[currentSceneId];
    const transformControlsActive = useSelector((state) => state.userReducer.transformControlsActive);
    const zeroMemoTuple3 = useMemo(() => [0, 0, 0], []);
    return _jsx(DragControls, { initialRotation: (tempDragRotation ?? currentScene?.content360?.initialCameraRotation ?? zeroMemoTuple3), forceUpdateInitialRotation: forceUpdateDragControlsTrigger, enabled: enabled && !transformControlsActive, zoomEnabled: false, horizontalMovementFactor: 0.4, verticalMovementFactor: 0.4, canvasElement: gl.domElement, camera: camera, enableCameraResetOnSceneLoad: true, useDragGroup: false });
};
export default DragControlsWrapper;
